module.exports = __webpack_public_path__ + "static/media/Employeemanage.151fe965.png";